import { getTokenCssVar } from '@vp/swan'

/** Overlay veil shown behind the flyout to dim page content */
const veilStyle: React.CSSProperties = {
  position: 'fixed',
  inset: 0,
  backgroundColor: getTokenCssVar('SwanSemColorFgSubtle'), // Semi-transparent background to dim content
  opacity: '0.5',
  zIndex: `calc(${getTokenCssVar('SwanSemZIndexOverlay')} - 1)`, // Ensure veil is behind the flyout
}

type VeilProps = {
  /** Whether the veil is visible */
  show: boolean
  /** Click handler to close the flyout when the veil is clicked */
  onClose: () => void
  /** Optional top offset so the veil starts below the flyout panel */
  top?: number
}

/**
 * Veil component that renders a semi-transparent overlay behind the flyout.
 * It captures click and mouse move events to allow closing the flyout when interacting outside of it.
 */

export default function Veil({ show, onClose, top }: Readonly<VeilProps>) {
  if (!show) return null
  return <div style={{ ...veilStyle, top }} onClick={onClose} onMouseMove={onClose} aria-hidden="true" />
}
